import { render, staticRenderFns } from "./TransferModal.vue?vue&type=template&id=65d15136&scoped=true"
import script from "./TransferModal.vue?vue&type=script&lang=js"
export * from "./TransferModal.vue?vue&type=script&lang=js"
import style0 from "./TransferModal.vue?vue&type=style&index=0&id=65d15136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d15136",
  null
  
)

export default component.exports